import React from 'react';

import useSurvey from './useSurvey';

import { Content, Card, Title, Question, Label, Radio, Input } from './styled';

function FormComponent() {
  const {
    _etc1, 
    state, onChangeToRadio,
  } = useSurvey();

  return (
    <Content>
      <Card className="Content">
        <Title>&lt;설문 내용&gt;</Title>

        <div>
          <Question>Q1. 2학기는 어디에서 등·하교 하시나요?</Question>

          <Label>
            <Radio name="q1" value="1" checked={state.q1 === 1} onChange={onChangeToRadio} />
            <p>학교 주변 자취방 (2번 문항으로 가세요.)</p>
          </Label>
          <Label>
            <Radio name="q1" value="2" checked={state.q1 === 2} onChange={onChangeToRadio} />
            <p>부모님 집 (5번 문항으로 가세요.)</p>
          </Label>
          <Label>
            <Radio name="q1" value="3" checked={state.q1 === 3} onChange={onChangeToRadio} />
            <p>학교 기숙사 (5번 문항으로 가세요.)</p>
          </Label>
          <Label>
            <Radio name="q1" value="4" checked={state.q1 === 4} onChange={onChangeToRadio} />
            <p>기타</p>
            <Input ref={_etc1} name="q1Etc" value={state.q1Etc} disabled={state.q1 !== 4} />
          </Label>
        </div>
      </Card>
    </Content>
  );
}

export default FormComponent;
